import React from "react";
import { workbench as W, tones } from "../mock/inferraData";
import { Dots } from "./primitives";

function Cite({ children }) {
  return <span style={{ color: "var(--green)" }}>{children}</span>;
}

export default function CreditWorkbench() {
  return (
    <div
      className="card-lift wb"
      style={{
        background: "#fff",
        border: "1px solid rgba(20,32,27,0.16)",
        borderRadius: 12,
        boxShadow: "0 40px 90px -50px rgba(20,32,27,0.5)",
        overflow: "hidden",
      }}
    >
      {/* top bar */}
      <div
        style={{
          height: 52,
          padding: "0 20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderBottom: "1px solid #e6e9e6",
          fontSize: 13,
          gap: 12,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <Dots />
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <svg width="16" height="16" viewBox="0 0 28 28" fill="none">
              <rect x="1.5" y="1.5" width="25" height="25" rx="3" stroke="#14201b" strokeWidth="2.5" />
              <rect x="8" y="8" width="12" height="12" rx="1.5" stroke="#0f5c4b" strokeWidth="2.5" />
            </svg>
            <span style={{ fontWeight: 600 }}>Credit workbench</span>
          </div>
        </div>
        <div className="wb-crumb" style={{ color: "#5a646e", fontSize: 12.5 }}>{W.breadcrumb}</div>
        <div style={{ display: "flex", alignItems: "center", gap: 10, color: "#5a646e" }}>
          <span className="wb-crumb">Credit analyst</span>
          <span
            style={{
              width: 28,
              height: 28,
              borderRadius: "50%",
              background: "var(--green-tint)",
              color: "var(--green)",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: 600,
              fontSize: 12,
            }}
          >
            {W.analyst}
          </span>
        </div>
      </div>

      {/* body */}
      <div className="wb-body" style={{ display: "flex", minHeight: 528 }}>
        {/* sidebar */}
        <div
          className="wb-side"
          style={{
            width: 200,
            flexShrink: 0,
            padding: "20px 12px",
            borderRight: "1px solid #e6e9e6",
            display: "flex",
            flexDirection: "column",
            gap: 4,
            fontSize: 14,
            color: "#45514a",
          }}
        >
          {W.tabs.map((t) => {
            const active = t === W.activeTab;
            return (
              <div
                key={t}
                className="wb-tab"
                style={{
                  padding: "9px 12px",
                  borderRadius: 6,
                  cursor: "pointer",
                  background: active ? "var(--green-tint)" : "transparent",
                  color: active ? "var(--green)" : "#45514a",
                  fontWeight: active ? 600 : 400,
                  transition: "background .2s ease, color .2s ease",
                }}
              >
                {t}
              </div>
            );
          })}
          <div style={{ flexGrow: 1 }} />
          <div
            style={{
              padding: 12,
              borderRadius: 8,
              background: "#f4f6f4",
              fontSize: 12,
              lineHeight: 1.5,
              color: "#5a646e",
            }}
          >
            Runs on bank hardware. No outbound data path.
          </div>
        </div>

        {/* main */}
        <div className="wb-main" style={{ flexGrow: 1, padding: "24px 28px", display: "flex", flexDirection: "column", gap: 16, minWidth: 0 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", gap: 12 }}>
            <div style={{ fontSize: 18, fontWeight: 600 }}>{W.spreadTitle}</div>
            <div style={{ fontSize: 12, color: "#5a646e", textAlign: "right" }}>{W.spreadSub}</div>
          </div>

          <div style={{ display: "flex", flexDirection: "column" }}>
            <div style={gridRow(true)}>
              <span>{W.columns[0]}</span>
              {W.columns.slice(1).map((c, i) => (
                <span key={i} style={{ textAlign: "right" }}>{c}</span>
              ))}
            </div>
            {W.rows.map((r, i) => (
              <div
                key={r.k}
                style={{
                  ...gridRow(false),
                  background: r.hi ? "#f4f8f6" : "transparent",
                }}
              >
                <span className="font-sans" style={{ fontWeight: r.hi ? 600 : 400 }}>{r.k}</span>
                {r.v.map((v, j) => (
                  <span key={j} style={{ textAlign: "right", fontWeight: r.hi && j === 2 ? 600 : 400 }}>{v}</span>
                ))}
                <span style={{ textAlign: "right", color: r.calc ? "#5a646e" : "var(--green)" }}>{r.src}</span>
              </div>
            ))}
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 12,
              padding: "12px 14px",
              borderRadius: 8,
              background: "#f4f6f4",
              fontSize: 13,
              color: "#45514a",
            }}
          >
            <svg width="18" height="18" viewBox="0 0 20 20" fill="none" style={{ flexShrink: 0 }}>
              <circle cx="10" cy="10" r="8.5" stroke="#0F5C4B" strokeWidth="1.6" />
              <path d="M6 10.2l2.6 2.6L14 7.4" stroke="#0F5C4B" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <span>{W.check}</span>
          </div>
        </div>

        {/* right memo */}
        <div
          className="wb-right"
          style={{
            width: 360,
            flexShrink: 0,
            padding: 24,
            borderLeft: "1px solid #e6e9e6",
            background: "#fafbfa",
            display: "flex",
            flexDirection: "column",
            gap: 18,
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div style={{ fontSize: 14, fontWeight: 600 }}>{W.memo.title}</div>
            <span
              style={{
                fontSize: 11,
                padding: "4px 8px",
                borderRadius: 4,
                background: "#f6eedd",
                color: "#7a4f0e",
              }}
            >
              {W.memo.status}
            </span>
          </div>
          <p className="font-type" style={{ margin: 0, fontSize: 17, lineHeight: 1.5, color: "var(--ink)" }}>
            {W.memo.lead}
          </p>
          <p style={{ margin: 0, fontSize: 13, lineHeight: 1.65, color: "#45514a" }}>
            Leverage fell from 3.0x to 2.1x over three years as EBITDA grew 25% <Cite>[p. 22]</Cite>. Reported revenue agrees with e-invoice records <Cite>[e-invoice summary]</Cite>.
            <span style={{ marginLeft: 2, borderLeft: "2px solid var(--green)", animation: "caret 1.1s step-end infinite" }}>&nbsp;</span>
          </p>
          <div style={{ height: 1, background: "#e6e9e6" }} />
          <div style={{ display: "flex", flexDirection: "column", gap: 10, fontSize: 13 }}>
            {W.memo.facts.map(([k, v], i) => (
              <div key={i} style={{ display: "flex", justifyContent: "space-between", gap: 10 }}>
                <span style={{ color: "#5a646e" }}>{k}</span>
                <span style={{ fontWeight: 500, color: i === 3 ? "var(--green)" : "inherit", fontFamily: i === 2 ? '"IBM Plex Mono", monospace' : "inherit" }}>{v}</span>
              </div>
            ))}
          </div>
          <div style={{ flexGrow: 1 }} />
          <a href="#how" className="btn btn--dark" style={{ height: 44, borderRadius: 6, fontSize: 14 }}>
            Send to checker
          </a>
        </div>
      </div>

      <style>{`
        .wb-tab:hover { background: rgba(15,92,75,0.06); color: var(--green); }
        @media (max-width: 1080px) {
          .wb-crumb { display: none; }
          .wb-right { width: 300px; }
        }
        @media (max-width: 900px) {
          .wb-body { flex-direction: column; }
          .wb-side { width: 100%; flex-direction: row; flex-wrap: wrap; border-right: none; border-bottom: 1px solid #e6e9e6; }
          .wb-side > div:last-child { display: none; }
          .wb-right { width: 100%; border-left: none; border-top: 1px solid #e6e9e6; }
        }
      `}</style>
    </div>
  );
}

function gridRow(head) {
  return {
    display: "grid",
    gridTemplateColumns: "170px repeat(3, minmax(0,1fr)) 74px",
    padding: head ? "8px 10px" : "9px 10px",
    borderBottom: head ? "1px solid #e6e9e6" : "1px solid #eef0ee",
    fontFamily: '"IBM Plex Mono", monospace',
    fontSize: head ? 12 : 13,
    color: head ? "#5a646e" : "var(--ink)",
  };
}
